module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step3-full-f956c5a21e62fa03738a46649cfa2e3f.jpg";